import { controls, grouped } from "../controls";
const member_loan_requests = {
  label: "Member Loan Requests",
  pageLabel: "Member Loan Requests", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Account" }),
    ...controls.oc({ tab: "filter", c: "Account", placeHolder: "Account Code", name: "MemberLoanRequest-account-account_code", fastpath: "accounts" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "MemberLoanRequest-account-account_display" }),
    ...controls.displayText({ tab: "filter", label: "Crop" }),
    ...controls.oc({ tab: "filter", c: "Crop", placeHolder: "Crop Code", name: "MemberLoanRequest-crop-crop_code", fastpath: "crops" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "MemberLoanRequest-crop-crop_display" }),
    ...controls.displayText({ tab: "filter", label: "From Amount" }),
    ...controls.floatOnly({ tab: "filter", placeHolder: "", name: "from_amount", maxlength: 21 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "To Amount" }),
    ...controls.floatOnly({ tab: "filter", placeHolder: "", name: "to_amount", maxlength: 21 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To Date", target: "to_date" }),
    ...controls.magicDate({ tab: "filter", name: "to_date", dateType: "ontype" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [

    {
      widths: "col-sm-9",
      tab: "general",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        ...controls.displayText({ tab: "general", label: "Account", star: true }),
        ...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", width: 'col-sm-3', name: "account_code", isRequired: true, fastpath: "accounts", isReadOnly: "edit", liveValidation: ["amount"] }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "account_display", width: "col-sm-7" }),
        ...controls.displayText({ tab: "general", label: "Farm", star: true }),
        ...controls.oc({ tab: "general", c: "Farm", placeHolder: "Farm", width: 'col-sm-3', name: "farm_code", isRequired: true, fastpath: "farms" }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "farm_display", width: "col-sm-7" }),
        ...controls.displayText({ tab: "general", label: "Crop", star: true }),
        ...controls.oc({ tab: "general", c: "Crop", placeHolder: "Crop Code", width: 'col-sm-3', name: "crop_code", isRequired: true, fastpath: "crops" }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "crop_display", width: "col-sm-7" }),
        ...controls.displayText({ tab: "general", label: "Sub Crop", star: false }),
        ...controls.oc({ tab: "general", c: "SubCrop", placeHolder: "Sub Crop Code", width: 'col-sm-3', name: "sub_crop_code", isRequired: false, fastpath: "sub_crops" }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "sub_crop_display", width: "col-sm-7" }),
        ...controls.displayText({ tab: "general", label: "Plantation Area" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "plantation_area", width: 'col-sm-3', maxlength: 6 }),
        ...controls.displayText({ tab: "general", label: "Amount" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "amount", width: 'col-sm-3', maxlength: 18 }),
        ...controls.FileUpload({ tab: "general", name: "url_7_12", options: { max: 120000, type: "image" } }),

      ]
    },
    grouped.acinfo('general')
  ]
  , history: {
    perPage: 10,
    reportHeader: "Member Loan Requests",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Createdat", accessor: "createdat", type: 'date' },
      { Header: "Account Code", accessor: "MemberLoanRequest-account-account_code", },
      { Header: "Crop", accessor: "MemberLoanRequest-crop-crop_display", },
      { Header: "Amount", accessor: "amount", },
    ]
  }
};
export default member_loan_requests;